import React from "react";
import { motion } from "framer-motion";

export const Eyebrow = ({ children, className = "", ...rest }) => (
  <span
    {...rest}
    className={`inline-flex items-center gap-3 text-[10px] font-semibold uppercase tracking-[0.25em] text-[#E85D2F] ${className}`}
  >
    <span className="h-px w-8 bg-[#E85D2F]" />
    {children}
  </span>
);

export const SectionHeading = ({ eyebrow, title, kicker, align = "left", className = "" }) => (
  <div
    className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""} ${className}`}
  >
    {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
    <h2 className="mt-6 font-grotesk text-4xl md:text-5xl lg:text-6xl font-black tracking-tighter leading-[0.95] text-[#F7F5F0] text-balance">
      {title}
    </h2>
    {kicker && (
      <p className="mt-6 text-base md:text-lg text-[#F7F5F0]/70 leading-relaxed font-light max-w-2xl">
        {kicker}
      </p>
    )}
  </div>
);

export const FadeUp = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Pill = ({ children, className = "" }) => (
  <span
    className={`inline-flex items-center gap-2 rounded-full border border-[#E85D2F]/30 bg-[#121211]/60 px-4 py-1.5 text-xs tracking-wide text-[#E85D2F] ${className}`}
  >
    {children}
  </span>
);
